<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_406_2682)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.668718 14.3259C0.861538 14.4295 1.07179 14.4818 1.28205 14.4818C1.52615 14.4818 1.76821 14.4131 1.98051 14.2746L3.84308 13.0674C3.92485 13.014 4.0119 12.9706 4.10258 12.9377V14.1444C4.10258 15.7003 5.3672 16.9649 6.9231 16.9649H14.8534C15.4985 16.9649 16.1262 17.1495 16.6677 17.5003L18.0195 18.3772C18.2318 18.5156 18.4749 18.5844 18.718 18.5844C18.9282 18.5844 19.1385 18.5341 19.3313 18.4295C19.7436 18.2049 20 17.7731 20 17.3033V7.99052C20 6.43462 18.7354 5.17001 17.1795 5.17001H15.8974V3.88692C15.8974 2.33102 14.6328 1.06641 13.0769 1.06641H2.82051C1.26462 1.06641 0 2.33102 0 3.88692V13.1997C0 13.6695 0.25641 14.1013 0.668718 14.3259ZM15.8974 6.70847V10.0408C15.8974 11.5967 14.6328 12.8613 13.0769 12.8613H5.64105V14.1444C5.64105 14.851 6.21643 15.4264 6.9231 15.4264H14.8534C15.7959 15.4264 16.7118 15.6982 17.5036 16.21L18.4616 16.8305V7.99052C18.4616 7.28385 17.8862 6.70847 17.1795 6.70847H15.8974ZM1.53846 3.88692C1.53846 3.18025 2.11385 2.60487 2.82051 2.60487H13.0769C13.7836 2.60487 14.359 3.18025 14.359 3.88692V10.0408C14.359 10.7474 13.7836 11.3228 13.0769 11.3228H4.53949C3.99282 11.3228 3.46154 11.4797 3.00513 11.7772L1.53846 12.7279V3.88692Z"
        fill="#9C9C9C"
      />
    </g>
    <defs>
      <clipPath id="clip0_406_2682">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
